import React from "react";
import { HashtagAction } from "../../../actions";
import ColorSelection from "../../../components/colorSelection";
import { COLORS } from "../../../constants/hashtags";
import { withRouter } from "react-router-dom";
import SubItemAddEditForm from "../../../hocs/tools/addOrEdit";
import { REDUCER_NAMES } from "../../../constants/reducerNames";
import {TEAM_PERMISSIONS} from "../../../constants/teamManagement";

const Index = props => {
  const {
    input: { value, onChange }
  } = props;
  return (
    <React.Fragment>
      <ColorSelection
        colors={COLORS}
        title="هشتگ"
        selectColor={value => {
          onChange(value);
        }}
        value={value}
      />
    </React.Fragment>
  );
};

const initColor = COLORS[0];

export default withRouter(
  SubItemAddEditForm(
    {
      title: "هشتگ",
      reducer_name: REDUCER_NAMES.SUB_ITEMS.HASHTAG,
      singleItem: "hashtag",
      extraField: { name: "color", initializedValue: initColor },
      get: id => HashtagAction.show(id),
      getList: () => HashtagAction.getList(),
      addItem: data => HashtagAction.store(data),
      editItem: (id, data) => HashtagAction.update(id, data),
      accounting: false,
      changePermissionsFieldName: TEAM_PERMISSIONS(true).HASHTAG
    },
    Index
  )
);
